module.exports = __webpack_public_path__ + "static/media/creditCards-amex.a2a08256.svg";